import { type UploadFileData } from "@src/appV2/lib/Media/types";

export enum BadgeVerificationStep {
  INTRO = "intro",
  TAKE_PHOTO = "take-photo",
  CONFIRM = "confirm",
  NO_BADGE = "no-badge",
  SKIP_CONFIRM = "skip-confirm",
  SKIP_RESULT = "skip-result",
}

export interface BadgeVerificationPhoto extends UploadFileData {
  previewUrl: string;
}
